import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function absoluteUrl(path: string, customBaseUrl?: string) {
  const baseUrl = customBaseUrl || process.env.NEXT_PUBLIC_APP_URL;

  if (!baseUrl) {
    // In a server environment where the request object is available, this should not be thrown.
    // This serves as a fallback for client-side usage or other contexts.
    throw new Error(
      "CRITICAL: Base URL is not defined. Provide it via customBaseUrl or set NEXT_PUBLIC_APP_URL environment variable."
    );
  }

  // Ensure the base URL is valid
  try {
    new URL(baseUrl);
  } catch (error) {
    throw new Error(
      `CRITICAL: Invalid base URL: "${baseUrl}". It must be a valid, absolute URL (e.g., "https://example.com").`
    );
  }

  // Ensure we don't have double slashes
  const finalBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const finalPath = path.startsWith('/') ? path : `/${path}`;

  return `${finalBaseUrl}${finalPath}`;
}
